import styles from './styles.module.scss';

import React from 'react';
import { NavLink } from 'react-router-dom';

import cn from 'classnames';

const LinkBlue = ({ to = '', children, ...props }) => (
  <NavLink to={to} className={cn(styles.link_blue, props.styles)} style={props.style} {...props}>
    {children}
  </NavLink>
);

export default LinkBlue;
